module.exports = __webpack_public_path__ + "static/home-feature-4-v3-dae18d471c792ac829b8c02b8061299d.svg";